import { fetchData } from '../fetchService';
import {
	AuthKeys,
	Definition,
	GetListRequest,
	GetPolicyResponse,
	ListPoliciesResponse,
	ResponseWitOutData,
} from '../types';
import { toSearchParams } from '../helpers/common';

const securityPolicyService = {
	async create(
		baseUrl: string,
		policy: string,
		data: Definition,
		authKeys?: AuthKeys,
	): Promise<ResponseWitOutData> {
		return await fetchData(
			`${baseUrl}/policy?policy=${policy}`,
			'POST',
			data,
			authKeys,
		);
	},
	async get(
		baseUrl: string,
		policy: string,
		authKeys?: AuthKeys,
	): Promise<GetPolicyResponse> {
		return await fetchData(
			`${baseUrl}/policy?policy=${policy}`,
			'GET',
			null,
			authKeys,
		);
	},
	async delete(
		baseUrl: string,
		policy: string,
		authKeys?: AuthKeys,
	): Promise<ResponseWitOutData> {
		return await fetchData(
			`${baseUrl}/policy?policy=${policy}`,
			'DELETE',
			null,
			authKeys,
		);
	},
	async getList(
		baseUrl: string,
		data?: GetListRequest,
		authKeys?: AuthKeys,
	): Promise<ListPoliciesResponse> {
		const query = toSearchParams({ ...data });
		return await fetchData(
			`${baseUrl}/policy/match${query ? `?${query}` : ''}`,
			'GET',
			null,
			authKeys,
		);
	},
};

export default securityPolicyService;
